module.exports = __webpack_public_path__ + "android-chrome-512x512.png";